import { Box, BoxProps, forwardRef } from '@chakra-ui/react';

export type { BoxProps as SkeletonBoxProps };

/**
 * SkeletonBox is just a Box with default background color.
 */
const SkeletonBox = forwardRef<BoxProps, 'div'>((props, ref) => {
  return <Box backgroundColor="neutral.93" {...props} ref={ref} />;
});

export default SkeletonBox;
